<section class="grid gap-2 pb-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Employee detail'"></page-title>
    </div>
    <a mat-stroked-button routerLink="/employees">Back to list</a>
  </div>

  @if (employeeStore.selectedEmployee(); as employee) {
    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Member details">
        <ng-template matTabContent>
          <div class="grid gap-4 pt-4">
            <employee-form
              title="Update employee"
              submitLabel="Save employee"
              [busy]="employeeStore.saving()"
              [readOnly]="!canUpdate()"
              [initialValue]="employee"
              [clients]="clientStore.clients()"
              [clientCompanies]="clientStore.clientCompanies()"
              [countries]="lookupStore.items('COUNTRY')"
              [employmentTypes]="lookupStore.items('EMPLOYMENT_TYPE')"
              [genders]="lookupStore.items('GENDER')"
              [groupProducts]="lookupStore.items('GROUP_PRODUCT')"
              [maritalStatuses]="lookupStore.items('MARITAL_STATUS')"
              [medicalAids]="lookupStore.items('MEDICAL_AID')"
              [provinces]="lookupStore.items('PROVINCE')"
              [races]="lookupStore.items('RACE')"
              [titles]="lookupStore.items('TITLE')"
              [employeeStatuses]="lookupStore.items('EMPLOYEE_STATUS')"
              [companies]="employeeStore.companies()"
              [companyDivisions]="employeeStore.companyDivisions()"
              [companyJobTitles]="employeeStore.companyJobTitles()"
              [organisationalLevels]="employeeStore.organisationalLevels()"
              [managerLookupResponses]="employeeStore.managerLookupResponses()"
              [managerLookupLoading]="employeeStore.managerLookupLoading()"
              (clientChanged)="onClientChanged($event)"
              (companyChanged)="onCompanyChanged($event)"
              (managerLookupSearchChanged)="onManagerLookupSearchChanged($event)"
              (submitted)="saveEmployee($event)">

               <div class="col-start-2">
                <button
                  mat-stroked-button
                  type="button"
                  (click)="openDependantsManagement(employee)">
                  Manage dependants
                </button>
                </div>
                <div>
                @if ((employee.isActive && canDeactivate()) || (!employee.isActive && canActivate())) {
                  <button
                    matButton="filled"
                    class="mom-danger"
                    type="button"
                    [disabled]="employeeStore.activating() || employeeStore.deactivating()"
                    (click)="toggleEmployeeActive(employee)">
                    @if (employeeStore.activating() || employeeStore.deactivating()) {
                      <mat-spinner diameter="20" class="mr-2" />
                    }
                    {{ employee.isActive ? 'Deactivate' : 'Activate' }}
                  </button>
                }
               </div>
            </employee-form>

          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="History">
        <ng-template matTabContent>
          <div class="pt-4">
            <employee-history [history]="employeeStore.history()" />
          </div>
        </ng-template>
      </mat-tab>

      @if (canViewInterventions()) {
        <mat-tab label="Interventions">
          <ng-template matTabContent>
            <div class="pt-4 pb-1">
              <employee-interventions-panel [employeeId]="employee.id" />
            </div>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  } @else {
    <mat-card class="p-5">
      @if (employeeStore.loading()) {
        <div class="flex items-center gap-3 text-sm">
          <mat-spinner diameter="24" />
          Loading employee data...
        </div>
      } @else {
        <p class="text-sm">Employee data was not found.</p>
      }
    </mat-card>
  }
</section>